import React from 'react'
import { Route } from 'react-router'
import RedirectToPlural from '@/modules/layout/util/redirectToPlural'

const CreditNoteDetails = React.lazy(() => import('@/modules/credit-note/components/detail/credit-note-detail'))
const TransactionSendEmail = React.lazy(() => import('@/modules/transaction/components/email/transaction-send-email'))

const creditNoteRoutes = (
  <>
    <Route path='creditnote/*' element={<RedirectToPlural />} />
    <Route path='creditnotes/:id' Component={CreditNoteDetails} />
    <Route path='creditnotes/send/:id' Component={TransactionSendEmail} handle={{ options: { noBackgroundColor: true } }} />
  </>
)

export default creditNoteRoutes
